module.exports = __webpack_public_path__ + "img/xficon_07.87a9c337.png";